import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
  get_jury_profile_list_action, jury_changeSeq_action,
  jury_profile_delete_action,
} from "../../../actions/adminModule_action/juryProfile_action";
import { responseError } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

class JuryProfileList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      jury_id: "",
      Name: "",
      Description: "",
      is_active: "Active",
      jurylist: [],
      Email: "",
      Phone: "",
      Experience: "",
      isAccordionExpanded: false,
      currentPage: 1,
    };
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);

    this.setState({
      user_id: sessionStorage.getItem("user_id") || "",
    });
    this.getJuryList();
  }
  onDragEndJury = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    if (source.index === destination.index) return;

    const updatedList = [...this.state.jurylist];
    const [draggedItem] = updatedList.splice(source.index, 1);
    updatedList.splice(destination.index, 0, draggedItem);
    const updatedListWithSeqNo = updatedList.map((item, index) => ({
      ...item,
      seq_no: index + 1,
    }));

    const jurySequence_list = updatedListWithSeqNo.map((item) => ({
      jury_id: item.jury_id,
      seq_no: item.seq_no,
    }));

    this.props
      .jury_changeSeq_action(jurySequence_list)
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ jurylist: updatedListWithSeqNo });
          this.getJuryList(); // Refresh the data
        } else {
          responseError(data); // Handle error
        }
      })
      .catch((e) => {
        console.error("Error updating sequence:", e);
      });
  };
  getJuryList = () => {
    const { Name, Email, Phone, Experience, is_active } = this.state;
    this.setState({ isLoading: true });
    this.props.get_jury_profile_list_action(Name, Email, Phone, Experience, is_active === 'Active' ? 1 : 0)
      .then((data) => {
        if (data.error !== 1) {
          const sortedJuryList = [...data.data].sort((a, b) => a.seq_no - b.seq_no);
          this.setState({
            jurylist: sortedJuryList,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  handleDelete = (jury_id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Jury?"
    );

    if (confirmed) {
      this.props.jury_profile_delete_action(jury_id)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getJuryList();
          } else {
            responseError(data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  navigateJuryAdd = () => {
    this.props.navigate("/juryProfileAU");
  }

  navigateJuryUpdate = (jury_id) => {
    this.props.navigate(`/juryProfileAU`, {
      state: { jury_id: jury_id },
    });
  }

  clearFilters = () => {
    this.setState({
      Name: "", Email: "", Phone: '', Experience: '',
      is_active: 'Active'
    }, () => {
      this.getJuryList();
    });
  }

  updateItem = (item) => {
    this.setState({ currentPage: item });
  }
  juryRecords(jurylist) {
    // const { userList } =this.state
    return (
      <DragDropContext onDragEnd={this.onDragEndJury}>
        <Droppable droppableId="jurylist">
          {(provided) => (
            <table class="table table-bordered" id="dashboard-table" ref={provided.innerRef}
              {...provided.droppableProps}>
              <thead>
                <tr>
                  <th style={{ width: "15%" }}>Name</th>
                  <th style={{ width: "15%" }}>Email Address</th>
                  <th style={{ width: "15%" }}>Phone Number</th>
                  <th style={{ width: "15%" }}>Occupation</th>
                  <th style={{ width: "15%" }}>Experience</th>
                  <th style={{ width: "15%" }}>Status</th>
                  <th className="text-right" style={{ width: "4%" }}>
                  </th>
                </tr>
              </thead>
              <tbody id="myTable">
                {jurylist.length > 0 ? (
                  jurylist.map((data, index) => (
                    <Draggable
                      key={data.jury_id.toString()}
                      draggableId={data.jury_id.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={snapshot.isDragging ? "dragging" : ""}
                        >
                          <td>{data.Name}</td>
                          <td>{data.Email}</td>
                          <td>{data.Phone}</td>
                          <td>
                            {data.Occupation != null ? data.Occupation : "Not Available"}
                          </td>
                          <td>
                            {data.Experience != null ? data.Experience : "Not Available"}
                          </td>
                          <td>{data.is_active == 1 ? "Active" : "In-Active"}</td>
                          {/* <td>{data.is_active ? "Active" : "Inactive"}</td> */}
                          <td className="">
                            <a
                              href="javascript:void(0);"
                              title="Edit"
                              className="btn btn-sm ml-1"
                              onClick={() => this.navigateJuryUpdate(data.jury_id)}
                            >
                              <i class="fa fa-pencil-square-o text-primary mr-2"></i>
                            </a>
                            {data.is_active == 1 ? (
                              <a
                                title="Delete"
                                className="btn btn-sm delete_record"
                                onClick={() => this.handleDelete(data.jury_id)}
                              >
                                <i class="fa fa-trash-o text-danger"></i>
                              </a>
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      )}
                    </Draggable>
                  ))
                ) : (
                  <td colSpan={6} className="text-center">
                    No records found
                  </td>
                )}
                {provided.placeholder}
              </tbody>
            </table>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
  render() {
    const {
      isLoading,
      jurylist,
      currentPage,
      isAccordionExpanded,
      Name,
      Email,
      Phone,
      Experience,
      jury_id, is_active
    } = this.state;
    const recordsPerPage = 50;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = jurylist.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(jurylist.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">

            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div className="container-fluid">
                <div className="page-header">
                  <h2 class="mb-3 dashboard-tit  py-0 blog-name">List of Jury</h2>
                  <button class="btn btn-outline-primary" onClick={() => this.navigateJuryAdd()}>Add</button>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          {Name ? <>
                            <h5>
                              <b>Name :</b> <span>{Name}</span>
                            </h5>
                          </> : <></>}
                          {Email ? <>
                            <h5>
                              <b>Email Address :</b>  <span>{Email}</span>
                            </h5>
                          </> : <></>}
                          {Phone ? <>
                            <h5>
                              <b> Phone Number :</b> <span>{Phone}</span>
                            </h5>
                          </> : <></>}
                          {is_active ? <>
                            <h5>
                              <b>Status :</b>{" "}
                              <span>{is_active}</span>
                            </h5>
                          </> : <></>}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse p-2 ${isAccordionExpanded ? "show" : ""
                          }`}
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Name"
                                  value={Name}
                                  onChange={(e) =>
                                    this.setState({ Name: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Email</label>
                                <input
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Email"
                                  value={Email}
                                  onChange={(e) =>
                                    this.setState({ Email: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Phone</label>
                                <input
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Phone"
                                  value={Phone}
                                  onChange={(e) =>
                                    this.setState({ Phone: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-select"
                                  value={is_active}
                                  onChange={(e) => {
                                    this.setState({
                                      is_active: e.target.value,
                                    });
                                  }}
                                >
                                  <option key='Active' value="Active">Active</option>
                                  <option key='InActive' value="InActive">In-Active</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button onClick={() => this.getJuryList()} className="btn btn-outline-primary search_btn">Search</button>
                              &nbsp;
                              <button onClick={this.clearFilters} className="btn btn-outline-danger clr_btn">Clear</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.juryRecords(currentRecords)}
                      {jurylist.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
const mapDispatchToProps = {
  get_jury_profile_list_action,
  jury_profile_delete_action, jury_changeSeq_action
};

export default withRouter(
  connect(null, mapDispatchToProps)(JuryProfileList)
);
